module.exports = __webpack_public_path__ + "media/background-music.2e0e3e19.mp3";